import { Injectable, inject } from '@angular/core';
import { ActivityDataService } from '@warema/shared/company-search/data-access';
import { AppointmentRequestActivityType } from '@warema/shared/models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ActivityApiService {
    private readonly _activityDataService = inject(ActivityDataService);

    public getSelectedActivity(): Observable<AppointmentRequestActivityType> {
        return this._activityDataService.selectedActivity$;
    }

    public selectActivity(activityType: AppointmentRequestActivityType): void {
        this._activityDataService.selectActivity(activityType);
    }

    public validateActivity(): void {
        this._activityDataService.validateActivity();
    }
}
